import { Base_Url } from "../../Base Url/BaseUrl";
import { postApi } from "../../Api Method/ApiMethod";

const loginUrl = `${Base_Url}/auth/login`;

export const VerifyLoginCredential = async (params) => {
  const res = await postApi(loginUrl, params);

  return res;
};
